import { render, staticRenderFns } from "./VideoAdmin.vue?vue&type=template&id=d85ff29c&scoped=true&"
import script from "./VideoAdmin.vue?vue&type=script&lang=js&"
export * from "./VideoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85ff29c",
  null
  
)

export default component.exports